
import { getPartition } from './api.js'

import pageApiData from './utils/pageApiData.js'

const [ _getPartitionFromServer, _getPartition, _getPartitionSync ] = pageApiData.createFunctions(getPartition, 'Unable to get partition/state data from server.')


async function getPartitionName(id) {
  return (await _getPartition(id))?.description
}

async function getPartitionContactPhone(id, contactId) {
  let _partition = await _getPartition(id)

  if (_partition?.cst_contact) {
    return _partition.cst_contact[contactId]
  }
  else {
    return _partition?.contact_phone
  }
}

function getPartitionNameSync(id) {
  return (_getPartitionSync(id))?.description
}

function getPartitionContactPhoneSync(id) {
  return (_getPartitionSync(id))?.contact_phone
}

export default {
  getPartitionFromServer: _getPartitionFromServer,
  getPartition: _getPartition,
  getPartitionSync: _getPartitionSync,

  getPartitionName,
  getPartitionContactPhone,
  getPartitionNameSync,
  getPartitionContactPhoneSync,
}
